import React, { useState } from 'react';
import { Settings, Eye, EyeOff, Grip } from 'lucide-react';

const WidgetCustomizer = ({ availableWidgets, visibleWidgets, onToggleWidget, onReorderWidgets }) => {
  const [showCustomizer, setShowCustomizer] = useState(false);

  return (
    <>
      {/* Customizer Button */}
      <button
        onClick={() => setShowCustomizer(true)}
        className="fixed bottom-4 right-4 z-40 bg-blue-600 hover:bg-blue-700 text-white p-3 rounded-full shadow-lg transition-colors"
        title="Personalizar Dashboard"
      >
        <Settings className="w-6 h-6" />
      </button>

      {/* Customizer Modal */}
      {showCustomizer && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white dark:bg-gray-800 rounded-xl p-6 w-full max-w-md max-h-[80vh] overflow-y-auto">
            <div className="flex items-center justify-between mb-6">
              <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
                ⚙️ Personalizar Dashboard
              </h3>
              <button
                onClick={() => setShowCustomizer(false)}
                className="text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200"
              >
                ✕
              </button>
            </div>

            <div className="space-y-4">
              <p className="text-sm text-gray-600 dark:text-gray-400 mb-4">
                Escolha quais informações você deseja ver no seu dashboard:
              </p>

              {availableWidgets.map((widget) => (
                <div
                  key={widget.id}
                  className="flex items-center justify-between p-3 bg-gray-50 dark:bg-gray-700/50 rounded-lg"
                >
                  <div className="flex items-center space-x-3">
                    <div className="w-8 h-8 bg-blue-100 dark:bg-blue-900/20 rounded-lg flex items-center justify-center">
                      <widget.icon className="w-4 h-4 text-blue-600 dark:text-blue-400" />
                    </div>
                    <div>
                      <h4 className="font-medium text-gray-900 dark:text-white text-sm">
                        {widget.title}
                      </h4>
                      <p className="text-xs text-gray-500 dark:text-gray-400">
                        {widget.description}
                      </p>
                    </div>
                  </div>
                  
                  <button
                    onClick={() => onToggleWidget(widget.id)}
                    className={`p-2 rounded-lg transition-colors ${
                      visibleWidgets.includes(widget.id)
                        ? 'bg-green-100 text-green-600 dark:bg-green-900/20 dark:text-green-400'
                        : 'bg-gray-100 text-gray-400 dark:bg-gray-600 dark:text-gray-500'
                    }`}
                  >
                    {visibleWidgets.includes(widget.id) ? (
                      <Eye className="w-4 h-4" />
                    ) : (
                      <EyeOff className="w-4 h-4" />
                    )}
                  </button>
                </div>
              ))}
            </div>

            <div className="mt-6 pt-4 border-t border-gray-200 dark:border-gray-600">
              <p className="text-xs text-gray-500 dark:text-gray-400 text-center">
                Suas preferências são salvas automaticamente
              </p>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default WidgetCustomizer;